export const LOGIN_LOAD_REQUEST = 'LOGIN_LOAD_REQUEST';
export const LOGIN_LOAD_SUCCESS = 'LOGIN_LOAD_SUCCESS';
export const LOGIN_LOAD_FAILURE = 'LOGIN_LOAD_FAILURE';
